module.exports = __webpack_public_path__ + "media/ecom/VIPIcon-10cb030c.svg";